import AuditCrud from "../components/audit/AuditCrud";

const AuditPage = () => {
  return (
    <>
      <AuditCrud />
    </>
  );
};

export default AuditPage;
